import wixData from 'wix-data';

$w.onReady(function () {
	sort()
});

//Filter area
export function areaDD_change(event) {
    let tagsArray = $w('#selectionTags1').value;
    if (tagsArray === undefined) {
        $w("#dataset1").setFilter(wixData.filter()
            .contains("area", $w('#areaDD').value)
        );
    } else {
        $w("#dataset1").setFilter(wixData.filter()
            .hasAll("words", tagsArray)
            .contains("area", $w('#areaDD').value)
        );
    }
}
//filter Tags
export function selectionTags1_change(event) {
    let tagsArray = $w('#selectionTags1').value;
    if (tagsArray === undefined) {
        $w("#dataset1").setFilter(wixData.filter()
            .contains("area", $w('#areaDD').value)
        );
    } else {
        $w("#dataset1").setFilter(wixData.filter()
            .hasAll("words", tagsArray)
            .contains("area", $w('#areaDD').value)
        );
    }
}
//Clear
export function clear_click(event) {
    $w("#dataset1").setFilter(wixData.filter());
    $w('#areaDD').selectedIndex = undefined;
    $w('#selectionTags1').selectedIndices = null;
	sort()
}

function sort() {
    wixData.query("profile")
        .find()
        .then((result) => {
            const shuffledArray = shuffleArray(result.items); //add the shuffled array data to then repeaters
            $w('#repeater1').data = shuffledArray;
        })
        .catch((err) => {
            let errorMsg = err;
        });
}
//random array index
function getRandomIndex(min, max) {
    return Math.round(Math.random() * (max - min) + min);
}
//shuffle array data
function shuffleArray(dataArray) {
    for (let i = dataArray.length - 1; i > 0; i--) {
        let index = getRandomIndex(0, i);
        const temp = dataArray[i];
        dataArray[i] = dataArray[index];
        dataArray[index] = temp;
    }
    return dataArray;
}
